import { createSelector } from 'reselect';
import { activeTrackerId } from './selectors';

export const makeGetSelectedTrackerId = () =>
    createSelector(
        activeTrackerId,
        (tracker: number | null) => tracker,
    );
